// extracted by mini-css-extract-plugin
module.exports = {"CurrentStaffCourse":"InputBookingTargetWithStaff_CurrentStaffCourse__1tPl3","CurrentStaffCourse__Menu":"InputBookingTargetWithStaff_CurrentStaffCourse__Menu__1Cl0d"};